import { Badge } from 'src/components/Badge';
import { useIncompleteTaskCount } from 'src/models/staff/task/useIncompleteTaskCount';

export const TaskCountIndicator: React.FC = () => {
  const { data: count, isLoading } = useIncompleteTaskCount();

  return (
    <Badge
      invisible={isLoading}
      badgeContent={count ?? 0}
      color="primary"
      sx={{ mr: 2 }}
    />
  );
};
